const BLADE_PATH =
  'M85.094 64.4L72.83 55.235C60.296 45.87 53.219 42.83 49.356 42.01a4.23 4.23 0 0 0-1.687-3.21 4.256 4.256 0 0 0-2.352-.847c.22-1.795.656-3.781 1.576-5.176 2.093-3.18-.372-25.738-.856-36.072 0 0-1.561-1.279-1.688-.202-.795 6.682-1.26 10.595-1.806 15.2-1.844 15.52-.936 23.166.278 26.926a4.33 4.33 0 0 0-1.12 1.03 4.245 4.245 0 0 0-.349 4.519c-1.672.71-3.62 1.313-5.292 1.215-3.797-.219-22.102 13.19-30.81 18.776 0 0-.323 1.993.673 1.567 6.183-2.655 9.804-4.212 14.063-6.042 14.394-6.18 20.539-10.78 23.173-13.712a4.245 4.245 0 0 0 5.374-1.216c.066-.087.11-.186.167-.274 1.447 1.086 2.952 2.478 3.704 3.977 1.705 3.395 22.476 12.543 31.66 17.29.002 0 1.897-.71 1.03-1.359z';

const TOWER_PATH =
  'M42.545 48.61c-.104 3.46-.369 9.06-.555 13.59-.474 11.52-1.43 34.562-1.43 34.562h9.27l-1.891-48.23c-.336 1.012-5.01.886-5.394.078z';

let glowFilterSeq = 0;

const softGlowFilter = (filterId: string) => `
  <defs>
    <filter id="${filterId}" x="-60%" y="-60%" width="220%" height="220%" color-interpolation-filters="sRGB">
      <feGaussianBlur in="SourceAlpha" stdDeviation="3.5" result="blur" />
      <feFlood flood-color="#ffffff" flood-opacity="0.95" result="glowColor" />
      <feComposite in="glowColor" in2="blur" operator="in" result="softGlow" />
      <feMerge>
        <feMergeNode in="softGlow" />
        <feMergeNode in="softGlow" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>`;

export const windTurbineIcon = (
  fillColor: string,
  /** Ring drawn around the icon — marks a Turbine out from its neighbours. */
  withRing?: boolean,
  circleColor?: string,
  /** Soft white halo behind the icon (satellite / busy imagery). */
  withSoftGlow: boolean = false
) => {
  // Unique id per icon so multiple markers in the same DOM do not clash
  const filterId = withSoftGlow ? `turbine-soft-glow-${++glowFilterSeq}` : '';
  const filterAttr = withSoftGlow ? ` filter="url(#${filterId})"` : '';

  return `<svg
      width="30"
      height="30"
      viewBox="0 0 80.521 101.091"
      overflow="visible"
      xmlns="http://www.w3.org/2000/svg"
    >
      ${withSoftGlow ? softGlowFilter(filterId) : ''}
      <g${filterAttr}>
        <path
          fill="${fillColor}"
          stroke="${fillColor}"
          stroke-width="3"
          d="${BLADE_PATH}" />
        <path
          fill="${fillColor}"
          stroke="${fillColor}"
          stroke-width="3"
          d="${TOWER_PATH}" />
      </g>
      ${
        withRing
          ? `
      <circle cx="42" cy="50" r="47" fill="none" stroke="${circleColor}" stroke-width="5" />`
          : ''
      }
    </svg>`;
};
